import { Tag } from "bbcode-to-react";
import * as React from "react";
class HeadingTag extends Tag {
    toHTML() {
        return [`<h3>`, this.getContent(), "</h3>"];
    }
    toReact() {
        return React.createElement("h3", null, this.getComponents());
    }
}
export default HeadingTag;
